module.exports = __webpack_public_path__ + "product-pure-powder-capsule-12.jpg?c19a6888ac23c65d8582e01278aba294";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-12.jpg
// module id = 94
// module chunks = 0